import React from 'react';
import './styles.css';
import { Flex, View } from '@smarterservices/smarter-ui';
import { useEffect, useRef } from 'react';
import Timeline from './Timeline';
import AnnotationOptions from './Annotations/AnnotationOptions';
import AnnotationLabels from './Annotations/AnnotationLabels';
import PlaybarTimer from './Timer';
import { getStore, usePlayerStore } from '../../../stores/StoreContext';
import RenderPopover from './Annotations/Popover';
import Volume from './Volume';

/**
 * Renders the video controls bar.
 *
 * The controls bar is a container for several controls, including a timeline,
 * play/pause button, timer, annotation options, and annotation labels.
 *
 * @returns {React.ReactElement} The controls bar.
 */
const Controls = () => {
  const LayoutStore = getStore('layoutStore');

  // We can only show this if the video is ready to play...
  const hlsPlaybackReady = usePlayerStore((state) => state.hlsPlaybackReady);

  if (!hlsPlaybackReady) {
    return null;
  }

  return (
    <View as="div" id="video-control-bar-wrapper">
      <Flex
        as="div"
        direction="row"
        withVisualDebug={false}
        id="video-controls"
        alignItems="center"
        elementRef={(el) => {
          LayoutStore.setMediaControlsRef(el);
        }}
      >
        <Flex.Item shouldGrow align="start">
          <Timeline />
        </Flex.Item>
        <Flex.Item padding="none none none x-small" align="start">
          <View as="div" height="40px" padding="xx-small 0 0 0">
            <PlaybarTimer />
            <Volume />
            <AnnotationOptions />
          </View>
          <AnnotationLabels />
        </Flex.Item>
      </Flex>
      {hlsPlaybackReady && <RenderPopover />}
    </View>
  );
};

export default Controls;
